/**
 * @module app.prospection.store.storeListCtrl
 */
let moment = require('moment');

function StoreListCtrl($rootScope, departementsService, localstores, storeService, activitiesService, mode, $scope, $filter, $q, Notification) {
    // $scope.selectActiveMenu(2);
    var self = this;

    const DEFAULT_ZOOM_LEVEL = 9;

    const LAST_APPOINTMENT_DATE_FILTER_TYPE = 0;
    const CONTRACT_END_DATE_FILTER_TYPE = 1;
    const DISTANCE = 2;

    self.stores = localstores.stores;
    self.filteredStores = self.stores;
    self.nullContractDateEndStores = [];
    self.vipStores = [];
    self.error = false;
    self.mode = mode;
    self.center = {};
    self.markers = {};
    self.defaults = { gestureHandling :true }
    self.isAdgencyRight = $rootScope.user.rights.adgency || $rootScope.user.rights.admin;
    self.isExportCsv = $rootScope.user.rights.csv || $rootScope.user.rights.admin;
    self.limit = self.isAdgencyRight ? 10000 : 250;
    self.loading = false;
    self.isTA = false;

    self.events = {
        map: {
            enable: ['zoomlevelschange', 'move', 'viewreset'],
            logic: 'emit'
        }
    };

    self.nbScreen = () => {
        return self.filteredStores.reduce((curr, store) => {
            if (store.est_compte_de_test === 0 && store.adgency)
                curr += store.adgency.nbScreens || 0;
            return curr;
        }, 0);
    };

    self.audienceOneWeek = () => {
        return self.filteredStores.reduce((curr, store) => {
            if (store.est_compte_de_test === 0 && store.adgency)
                curr += store.adgency.audiencePerWeek || 0;
            return curr;
        }, 0);
    }

    self.contactOneWeek = () => {
        return self.filteredStores.reduce((curr, store) => {
            if(store.est_compte_de_test === 0 && store.adgency)
                curr += store.adgency.visitsPerWeek || 0;
            return curr;
        },0);
    }

    self.controls = {
        scale: {
            metric: true,
            imperial: false
        }
    };

    if (!localstores.success) {
        self.error = localstores.error;
    }

    // Initialisation du conteneur pour les variables globales dans le root scope
    if (!$rootScope.stores) {
        $rootScope.stores = {};
    }
    if (!$rootScope.stores.filters) {
        $rootScope.stores.filters = {};
    }

    // Affichage de la liste des stores
    // On récupère les departements selectionnés
    // Affichage du secteur
    self.departementsList = mode.list && mode.list.join(', ');

    self.displayAudience = !!$rootScope.user.rights.adgency && self.mode.query.indexOf('activeScreen=true') !== -1 && ['advanced','geo', 'geo-multi'].indexOf(self.mode.name) !== -1;

    self.displayTestAcount = false;
    self.displayOldStores = false;
    // Récupération de la configuration de la position de la carte
    self.userMapCenter = $rootScope.stores && $rootScope.stores.userMapCenter;

    $scope.$on('leafletDirectiveMap.mapStore.move', function(event) {
        _saveUserMapCenter();
    });

    self.stateOptions = [
        // { state: '', label: 'Tout', code: '', icon: '', color: 'white' },
        { state: 'EAIN', label: 'Pré-client', code: 'pre-client', icon: 'fa-check', color: '#5bc0de', class: 'state_0' },
        { state: 'INST', label: 'Client', code: 'client', icon: 'fa-check-circle-o', color: '#b9d4ec', class: 'state_1' },
        { state: 'RESI', label: 'Ancien client', code: 'ancien-client', icon: 'fa-close', color: '#f0ad4e', class: 'state_2' },
        { state: 'EATC', label: 'Prospect', code: 'prospect', icon: 'fa-circle-o', color: '#c7e6c7', class: 'state_3' },
        { state: 'ANPR', label: 'Ancien Propriétaire', code: 'ancien-proprietaire', icon: 'fa-circle-o', color: '#d9534f', class: 'state_4' },
        { state: 'EARP', label: 'Attente Reprise', code: 'attente-reprise', icon: 'fa-circle-o', color: '#777777', class: 'state_5' }
    ];

    self.networkOptions = [
        { state: '300', label: 'Bimedia' },
        { state: '302', label: 'Devlyx' },
        { state: '304', label: 'Futurosoft'},
        { state: '003', label: 'NAP'}
    ]

    self.marketOptions = [
        { state: '001', label: 'Tabac Presse', code: 'tabacpresse' },
        { state: '002', label: 'Boulangerie', code: 'boulangerie' },
        { state: '003', label: 'Autres PDV', code: 'autre' },
        { state: '011', label: 'Fleuriste', code: 'fleuriste' },
        { state: '012', label: 'Restauration', code: 'restauration' },
        { state: '014', label: 'Bar', code: 'bar'}
    ];

    self.procheBureau = [
        {state: '1', label: 'Non renseigné'},
        {state: '2', label: 'Eloigné'},
        {state: '3', label: 'Proche bureau de poste'},
        {state: '4', label: 'Proche bureau de poste Dynamique'}
    ];

    self.segments = [
        {state: 'A : + de 300K Hab.', label: 'A : + de 300K Hab.'},
        {state: 'B : + de 150K Hab.', label: 'B : + de 150K Hab.'},
        {state: 'C : + de 100K Hab.', label: 'C : + de 100K Hab.'},
        {state: 'D : + de 50K Hab.', label: 'D : + de 50K Hab.'},
        {state: 'E : + de 40K Hab.', label: 'E : + de 40K Hab.'},
        {state: 'F : + de 30K Hab.', label: 'F : + de 30K Hab.'},
        {state: 'Inconnu', label: 'Inconnu'},
    ];

    self.TA = [
        {state: 'A+', label: 'A+'},
        {state: 'A', label: 'A'},
        {state: 'B', label: 'B'},
        {state: 'C', label: 'C'}
    ]

    self.activities = activitiesService.list();

    self.allServices = [];

    self.selectedChange = (labelArray, listItem, activeItem) => {
        self[labelArray] = [];
        for (const item of Object.keys(activeItem)) {
            if (activeItem[item]) {
                let res = listItem.find(i => i.id === item || i === item);
                self[labelArray].push(res.label ? res.label : res);
            }
        }
        self[labelArray] = self[labelArray].join(', ');
    }

    self.applyFiltersToStores = function applyFiltersToStores() {
        return self.getAllServices().then(() =>{
            return _getStoresAfterApplyingFilters(self.stores, self.userFilters, self.userFilterType)
                .then(function(filteredStores) {
                    self.filteredStores = filteredStores;
                });
        });

    };

    self.getAllServices = () => {
        if(self.allServices.length === 0){
            return storeService.getAllServices()
                .then(services => {
                    services.forEach(service => {
                        self.allServices.push({state: service.id, label: service.nom});
                    });
                }).then(()=>{
                    self.allServices.sort((stateA, stateB) => {
                        if (stateA.label < stateB.label) {
                            return -1;
                        }
                        if (stateA.label > stateB.label) {
                            return 1;
                        }
                        return 0;
                    });
                _initFilters();
            });
        }
        return Promise.resolve();
    }

    // Gestion des filtres
    if ('filterType' in $rootScope.stores.filters && self.mode.name !== 'geo' && self.mode.name !== 'geo-multi') {
        self.userFilterType = $rootScope.stores.filters.filterType;
    }
    else if (self.mode.name === 'geo' /*|| self.mode.name === 'geo-multi'*/) {
        self.userFilterType = DISTANCE;
    }
    else {
        self.userFilterType = LAST_APPOINTMENT_DATE_FILTER_TYPE;
    }

    if ('userFilters' in $rootScope.stores.filters) {
        self.userFilters = $rootScope.stores.filters.userFilters;
    }
    else {
        _initFilters();
    }

    self.generateCsv = function() {
        self.loading = true;
        let data = {
            stores: self.filteredStores,
            isAdgency : self.displayAudience
        };
        storeService.generateCsv(data)
            .then(csv => {
                self.loading = false;
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = csv;
                a.download = 'export.csv';
                a.click();
                URL.revokeObjectURL(csv)
                // $window.open(csv);
        }).catch(err => {
            self.loading = false;
            Notification.error('Une erreur est survenue : ' + err.data);
        });

    };

    /**
     * Actions performed when a user filter is modified
     */
    self.onFilterChange = function() {
        self.applyFiltersToStores().then(function() {
            _setMarkers(self.filteredStores, true);
            $rootScope.stores.filters.userFilters = self.userFilters;
        });
    };

    /**
     * return the store's after applying the user filters
     * @param  {Array} stores
     * @param  {Object} userFilters
     * @param  {Integer} filterType
     * @return {promise}
     */
    function _getStoresAfterApplyingFilters(stores, userFilters, filterType) {
        var d = $q.defer();
        let filteredStores = stores;
        let filters = {};

        // Common filters
        filters = {
            $: userFilters.searchFulltext,
        };

        if(!self.displayTestAcount) {
            filteredStores = filteredStores.filter(s => s.est_compte_de_test === 0);
        }

        if(!self.displayOldStores){
            filteredStores = filteredStores.filter(s => s.etat_magasin != 4)
        }

        if (userFilters.vip) {
            filters.est_vip = 1;
        }
        if (userFilters.withoutContractEndDate) {
            filters.qualification = { fin_contrat: '!' };
        }
        if (userFilters.withoutLastAppointmentDate) {
            filters.date_dernier_rdv = '!';
        }

        // Specific contract end date filter
        if (userFilters.searchContractEndDate) {
            filteredStores = $filter('filter')(
                filteredStores,
                { qualification: { fin_contrat: userFilters.searchContractEndDate } },
                function(currentYear, expectedYear) {
                    if (currentYear && parseInt(moment(currentYear).format('YYYY')) === expectedYear) {
                        return true;
                    }
                    return false;
                }
            );
        }

        // Specific last appointment date filter
        if (userFilters.searchLastAppointmentDate) {
            filteredStores = $filter('filter')(
                filteredStores,
                { date_dernier_rdv: userFilters.searchLastAppointmentDate },
                function(currentYear, expectedYear) {
                    if (currentYear && parseInt(moment(currentYear).format('YYYY')) === expectedYear) {
                        return true;
                    }
                    return false;
                }
            );
        }

        filteredStores = $filter('filter')(filteredStores, filters);

        // ACTIVITY
        const MONEY_TRANSFER_ACTIVITY = 'TRANSFERT ARGENT';
        const MONEY_TRANSFER_SERVICES = ['MG', 'RIA', 'OMF', 'WU'];

        self.isTA = !!userFilters.activity[MONEY_TRANSFER_ACTIVITY];
        _updateMoneyTransferServices(userFilters, self.isTA);

        const hasActivityFilters = Object.keys(userFilters.activity).length > 0;
        const hasActiveFilters = !Object.values(userFilters.activity).every(value => value === false);

        if (hasActivityFilters && hasActiveFilters) {
            console.log(userFilters.activity);
            const isOnlyMoneyTransferActive = Object.keys(userFilters.activity).length === 1 &&
                userFilters.activity[MONEY_TRANSFER_ACTIVITY] === true;

            if (!isOnlyMoneyTransferActive) {
                filteredStores = _filterStoresByActivities(filteredStores, userFilters.activity);
            }
        }

        function _updateMoneyTransferServices(userFilters, isMoneyTransferActive) {
            MONEY_TRANSFER_SERVICES.forEach(service => {
                userFilters.services[service] = isMoneyTransferActive;
            });
        }

        function _filterStoresByActivities(stores, activityFilters) {
            return stores.reduce((filteredStores, store) => {
                Object.keys(activityFilters).forEach(activityKey => {
                    if (activityFilters[activityKey] && activityKey !== MONEY_TRANSFER_ACTIVITY) {
                        store.activities.forEach(activity => {
                            const storeAlreadyIncluded = filteredStores.find(existingStore =>
                                existingStore.identifiant_magasin === store.identifiant_magasin
                            );

                            if (activity.id === activityKey && !storeAlreadyIncluded) {
                                filteredStores.push(store);
                            }
                        });
                    }
                });
                return filteredStores;
            }, []);
        }

        // SERVICES
        if(Object.keys(userFilters.services).length > 0 && !Object.values(userFilters.services).every(value => value === false)){
            console.log(userFilters.services);
            filteredStores = filteredStores.reduce((curr, store)=> {
                for(const serv of Object.keys(userFilters.services)){
                    if(userFilters.services[serv])
                        store.services.forEach(service =>{
                            if(service.service_id === serv && service.service_etat === 'active'){
                                if(curr.find(s => s.identifiant_magasin === store.identifiant_magasin) === undefined)
                                    curr.push(store);
                            }
                        });
                }
                return curr;
            },[]);
        }

        if(Object.keys(userFilters.TA).length > 0 && !Object.values(userFilters.TA).every(value => value === false)){
            filteredStores = filteredStores.reduce((curr, store)=> {
                for(const key of Object.keys(userFilters.TA)){
                    if(userFilters.TA[key])
                        if(store.ranking === key){
                                curr.push(store);
                        }
                }
                return curr;
            },[]);
        }
        if(Object.keys(userFilters.network).length > 0 && !Object.values(userFilters.network).every(value => value === false)) {
            filteredStores = filteredStores.reduce((curr, store) => {
                for (const net of Object.keys(userFilters.network)) {
                    if (userFilters.network[net] && net === '003') {
                        if(self.displayAudience) {
                            if (store.stat2 && store.stat2 === net && store.stat3 === '300')
                                if (!curr.find(s => s.identifiant_magasin === store.identifiant_magasin))
                                    curr.push(store);
                        }else{
                            if (store.stat2 && store.stat2 === net)
                            if (!curr.find(s => s.identifiant_magasin === store.identifiant_magasin))
                                curr.push(store);
                        }
                    }
                    if (userFilters.network[net] && ['300', '302', '304'].indexOf(net) !== -1) {
                        if(self.displayAudience){
                            if (store.stat3 && store.stat3 === net && store.stat2 !== '003' )
                                if (!curr.find(s => s.identifiant_magasin === store.identifiant_magasin))
                                    curr.push(store);
                        }else {
                            if (store.stat3 && store.stat3 === net)
                                if (!curr.find(s => s.identifiant_magasin === store.identifiant_magasin))
                                    curr.push(store);
                        }

                    }
                }
                return curr;
            }, []);
        }

        if(Object.keys(userFilters.states).length > 0 && !Object.values(userFilters.states).every(value => value === false)) {
            filteredStores = filteredStores.reduce((curr, store) => {
                for (const state of Object.keys(userFilters.states)) {
                    if (userFilters.states[state]) {
                        if (store.etat_magasin_label && store.etat_magasin_label === state)
                            curr.push(store);
                    }
                }
                return curr;
            }, []);
        }

        if(Object.keys(userFilters.market).length > 0 && !Object.values(userFilters.market).every(value => value === false)) {
            filteredStores = filteredStores.reduce((curr, store) => {
                for (const key of Object.keys(userFilters.market)) {
                    if (userFilters.market[key])
                        if (store.stat1 && store.stat1 === key)
                            curr.push(store);
                }
                return curr;
            }, []);
        }
        if(Object.keys(userFilters.segment).length > 0 && !Object.values(userFilters.segment).every(value => value === false)) {
            filteredStores = filteredStores.reduce((curr, store) => {
                for (const seg of Object.keys(userFilters.segment)) {
                    if (userFilters.segment[seg]) {
                        if (store.segment && store.segment === seg)
                            curr.push(store);
                    }
                }
                return curr;
            }, []);
        }

        // limit - la limite ne s'applique pas aux résultats sur la carte ?
        // filteredStores = $filter('limitTo')(filteredStores, self.limit, 0);

        // order by
        if (filterType === CONTRACT_END_DATE_FILTER_TYPE) {
            filteredStores = $filter('orderBy')(filteredStores, '-qualification.fin_contrat');
        }
        else if (filterType === LAST_APPOINTMENT_DATE_FILTER_TYPE) {
            filteredStores = $filter('orderBy')(filteredStores, '+date_dernier_rdv');
        }
        else {
            filteredStores = $filter('orderBy')(filteredStores, '+index');
        }

        d.resolve(filteredStores);

        return d.promise;
    }

    /**
     * Select filter type
     * @param  {int} value // 0 = last appointment; 1 = contract date end filter; 2 = distance
     */
    self.onFilterTypeChange = function onFilterTypeChange(value) {
        self.userFilterType = value;
        _resetFilters();
        self.onFilterChange();
        $rootScope.stores.filters.filterType = self.userFilterType;
    };

    /**
     * Reset the filters
     */
    function _resetFilters() {
        self.filteredStores = self.stores;
        _initFilters();
        $rootScope.stores.userFilters = self.userFilters;
    }

    /**
     * Init the filters
     */
    function
    _initFilters() {
        self.userFilters = {
            vip: false,
            searchFulltext: '',
            states: {},
            market: {},
            activity: [],
            withoutContractEndDate: false,
            searchContractEndDate: '',
            searchLastAppointmentDate: '',
            withoutLastAppointmentDate: false,
            displayTable: true,
            displayMap: true,
            searchDistance: false,
            TA: {},
            network: {},
            segment: {},
            services: {}
        };
    }

    /**
     * Actions performed when the fulltext search is modified
     */
    self.onFilterSearchFulltextChange = function onFilterSearchFulltextChange() {
        // No value, reset filter
        if (!self.userFilters.searchFulltext) {
            self.onFilterChange();
            return;
        }
        // The stores are not filtered if the number of characters of the searched text is less than 3
        if (self.userFilters.searchFulltext.toString().length < 3) {
            return;
        }
        self.onFilterChange();
    };

    /**
     * Actions performed when the search by contract end date is modified
     */
    self.onFilterSearchContractEndDateChange = function onFilterSearchContractEndDateChange() {
        // No value, reset filter
        if (!self.userFilters.searchContractEndDate) {
            self.onFilterChange();
            return;
        }
        // The value is not a year value, abort
        if (
            self.userFilters.searchContractEndDate.toString().length < 4 ||
            self.userFilters.searchContractEndDate.toString().length > 4
        ) {
            return;
        }
        self.onFilterChange();
    };

    /**
     * Actions performed when the search by last appointment date is modified
     */
    self.onFilterSearchLastAppointmentDateChange = function onFilterSearchLastAppointmentDateChange() {
        // No value, reset filter
        if (!self.userFilters.searchLastAppointmentDate) {
            self.onFilterChange();
            return;
        }
        // The value is not a year value, abort
        if (
            self.userFilters.searchLastAppointmentDate.toString().length < 4 ||
            self.userFilters.searchLastAppointmentDate.toString().length > 4
        ) {
            return;
        }
        self.onFilterChange();
    };

    /**
     * Actions performed when the filter without contract end date is modified
     */
    self.onFilterContractEndDateChange = function onFilterContractEndDateChange() {
        if (self.userFilters.withoutContractEndDate) {
            self.userFilters.state = {'EATC': true}; // prospect
            self.userFilters.searchContractEndDate = '';
        }
        else {
            self.userFilters.state = {'EAIN': true, 'INST': true, 'RESI': true, 'EATC': true, 'ANPR': true, 'EARP': true};
        }
        self.onFilterChange();
    };

    function _setMarkers(stores, updateCenter) {
        self.markers = {};
        if (self.mode.name === 'geo') {
            self.markers['marker'] = {
                lat: parseFloat(self.mode.near.lat),
                lng: parseFloat(self.mode.near.long),
                title: 'Votre position',
                message: 'Vous êtes ici.',
                icon: {
                    type: 'vectorMarker',
                    viewBox: '0 0 32 52',
                    iconSize: [30 * 1.15, 50 * 1.15],
                    iconAnchor: [15 * 1.1, 50 * 1.1],
                    icon: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                    prefix: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                    iconColor: '',
                    markerColor: 'red',
                    extraClasses: ''
                }
            };
        }
        stores.forEach(function(store, i) {
            const clientState = store.etat_magasin_label;
            const marketNum = store.stat1 ? store.stat1 : null;
            if (self.mode.name === 'geo-multi') {
                self.markers['marker_' + store.adgency.reference.raison_sociale] = {
                    lat: parseFloat(store.adgency.reference.latitude),
                    lng: parseFloat(store.adgency.reference.longitude),
                    title: store.adgency.reference.raison_sociale,
                    message: 'Point de référence',
                    icon: {
                        type: 'vectorMarker',
                        viewBox: '0 0 32 52',
                        iconSize: [30 * 1.15, 50 * 1.15],
                        iconAnchor: [15 * 1.1, 50 * 1.1],
                        icon: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                        prefix: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                        iconColor: '',
                        markerColor: 'red',
                        extraClasses: ''
                    }
                };
            }
            if (store.contact && store.contact.latitude && store.contact.longitude) {
                self.markers['marker' + (i + 1)] = {
                    lat: parseFloat(store.contact.latitude),
                    lng: parseFloat(store.contact.longitude),
                    title: store.enseigne,
                    message: _formatMarkerMessage(store),
                    icon: {
                        type: 'vectorMarker',
                        viewBox: '0 0 32 52',
                        iconSize: [30 * 1.15, 50 * 1.15],
                        iconAnchor: [15 * 1.1, 50 * 1.1],
                        icon: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                        prefix: 'none', // Utilisation des icones Bimedia, mais ne doit pas être vide
                        iconColor: '',
                        markerColor: _getMarkerColor(clientState),
                        extraClasses: _getMarkerIconClass(marketNum)
                    }
                };
            }
        });

        if (updateCenter && Object.keys(self.markers).length > 0) {
            _setMapCenter(self.markers, self.userMapCenter);
        }

        /**
         * Initializes the map position
         */
        function _setMapCenter(markers, userMapCenter) {
            if (userMapCenter) {
                _setUserMapCenter(userMapCenter);
            }
            else {
                _setDefaultMapCenter(markers);
            }
        }

        /**
         * Initializes the position of the map with the user's configuration
         */
        function _setUserMapCenter(userMapCenter) {
            self.center = {
                lat: userMapCenter.lat,
                lng: userMapCenter.lng,
                zoom: userMapCenter.zoom
            };
        }

        /**
         * Initializes the default position of the map
         */
        function _setDefaultMapCenter(markers) {
            let firstMarker = _getFirstMarker(markers);
            self.center = {
                lat: firstMarker.lat,
                lng: firstMarker.lng,
                zoom: DEFAULT_ZOOM_LEVEL
            };
        }

        function _getMarkerColor(clientState) {
            for (let clientStateElement of self.stateOptions) {
                if (clientStateElement.state === clientState) {
                    return clientStateElement.color;
                }
            }
            return 'white';
        }

        function _getMarkerIconClass(marketNum) {
            let className = '';

            for (let marketElement of self.marketOptions) {
                if (marketElement.state === marketNum) {
                    className = 'marker-market-' + marketElement.code;
                    break;
                }
            }

            return className;
        }

        function _getFirstMarker(markers) {
            let firstKey = Object.keys(markers)[0];
            return markers[firstKey];
        }
    }

    function _formatMarkerMessage(store) {
        let message = '';
        if (store.hasOwnProperty('enseigne') && store.enseigne) {
            message += '<b>' + store.enseigne + '</b>';
        }
        if (store.hasOwnProperty('customers') && store.customers.length > 0) {
            if (message !== '') {
                message += '<br>';
            }
            message += store.customers[0].nom_client + ' ' + store.customers[0].prenom_client;
        }
        if (store.hasOwnProperty('identifiant_magasin')) {
            message += '<br/><br/>';
            message +=
                '<a href="#!/prospection/store/' + store.identifiant_magasin + '">Voir la fiche du point de vente</a>';
        }

        return message;
    }

    function _saveUserMapCenter() {
        $rootScope.stores.userMapCenter = self.center;
    }

    self.applyFiltersToStores().then(function() {
        _setMarkers(self.filteredStores, true);
    });

    /* Format Date time received as YYYY-MM-DD HH:MM:SS to remove the time part*/
    self.formatDateTime = function formatDate(date) {
        return date ? moment(date).format('YYYY-MM-DD') : '';
    };
}

StoreListCtrl.$inject = ['$rootScope', 'departementsService', 'localstores', 'storeService', 'activitiesService', 'mode', '$scope', '$filter', '$q', 'Notification'];

angular.module('app.prospection.store.storeListCtrl', []).controller('StoreListCtrl', StoreListCtrl);
